// extracted by mini-css-extract-plugin
export default {"tableLayoutFixed":"DiffLines-module__tableLayoutFixed__FACjYgy","compact":"DiffLines-module__compact__Z0caVUu"};